









































import Vue from "vue";
import VaCard from "../molecules/VaCard.vue";

export default Vue.extend({
  name: "SoftwareMagoDisplay",
  components: { VaCard },
  methods: {},
  computed: {
    links() {
      const links = this.$store.getters["cms/directLinks"];
      return Array.isArray(links)
        ? [...links].sort((a, b) => a.order - b.order)
        : links;
    },
  },
  async created() {
    this.$store.dispatch("cms/fetchDirectLinks");
  },
});
